module.exports = __webpack_public_path__ + "img/2.09202c19.png";